import { useLocation } from "react-router-dom"
import Distinctions from "./components/Distinctions"
import LessonViewer from "./components/LessonViewer";
import { useEffect, useState } from "react";
import AppTour from "../../../components/AppTour/AppTour";
import { getContentsByModule } from "../../../api/professoru/contents.api";
import { lessonPageTourSteps } from "../../../components/AppTour/ModuleTourSteps";
import { getYoutubeThumbnail } from "../../../helper/utility";
import { useTrackFirstVisit, ACTIVITY_TYPES } from "../../../hooks/useTrackFirstVisit";
import { useTrackModuleVisit, MODULE_VISIT_TYPES } from "../../../hooks/useTrackModuleVisit";
import { GETTING_STARTED_MODULE_ID, GETTING_STARTED_MODULE_TITLE, getProfessorULessonsForModule } from "./lessonsData";

const emptyGroupedModule = (moduleName) => ({
  [moduleName]: {
    walkthroughs: [],
    lessons: getProfessorULessonsForModule(moduleName),
    interview: []
  }
});

const LessonsPage = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search);
  const lesson = params.get("lesson");
  const moduleId = params.get("moduleId");
  const [runTour, setRunTour] = useState(false)

  useTrackFirstVisit(ACTIVITY_TYPES.PROFESSORU_LESSONS_FIRST_VISIT);
  useTrackModuleVisit(MODULE_VISIT_TYPES.PROFESSORU, "lessons", { moduleId, moduleName: lesson });
  const [groupedLessons, setGroupedLessons] = useState(null)
  const [selectedModuleId, setSelectedModuleId] = useState(moduleId);
  const [selectedModuleName, setSelectedModuleName] = useState(lesson);

  useEffect(() => {
    if (location.hash === "#start-tour") {
      setRunTour(true)
    }
  }, [location.hash])

  useEffect(() => {
    if (!selectedModuleId) return;

    if (selectedModuleId === GETTING_STARTED_MODULE_ID) {
      setGroupedLessons(emptyGroupedModule(GETTING_STARTED_MODULE_TITLE));
      return;
    }

    setGroupedLessons(null);

    getContentsByModule(selectedModuleId)
      .then((data) => {
        const grouped = data.reduce((acc, item, index) => {
          if (!acc[selectedModuleName]) {
            acc[selectedModuleName] = {
              walkthroughs: [],
              lessons: getProfessorULessonsForModule(selectedModuleName),
              interview: []
            };
          }

          const typeMap = {
            walkthroughs: "walkthroughs",
            guide: "walkthroughs",
            interview: "interview"
          };

          const groupKey = typeMap[item.type];
          if (!groupKey) return acc;

          acc[selectedModuleName][groupKey].push({
            id: index + 1,
            contentId: item._id,
            moduleId: item.moduleId,
            title: item.title,
            thumbnail: (item.content.mediaUrl && /youtube|youtu\.be/.test(item.content.mediaUrl)) ? getYoutubeThumbnail(item.content.mediaUrl) : (item.thumbnail?.url || item.thumbnail?.externalUrl || ""),
            type: "image",
            lessonType: item.type,
          });

          return acc;
        }, emptyGroupedModule(selectedModuleName));
        setGroupedLessons(grouped);
      })
      .catch((error) => {
        console.error("Failed to load contents by module:", error);
        setGroupedLessons(emptyGroupedModule(selectedModuleName));
      });
  }, [selectedModuleId, selectedModuleName]);

  const handleModuleChange = (nextModuleId, nextModuleName) => {
    setSelectedModuleId(nextModuleId);
    setSelectedModuleName(nextModuleName);
  };

  return (
    <div className="DataAnalyst-page py-5">
      <AppTour
        tourSteps={lessonPageTourSteps}
        runTour={runTour}
        setRunTour={setRunTour}
        tourName="professoru-lessons-page"
        moduleId={selectedModuleId || "professoru-lessons-page"}
      />
      <div className="container max-w-full">
        <Distinctions
          title={selectedModuleName}
          inputPlaceholder={"What do you want to achieve right now?"}
        />
        <div data-tour="lesson-viewer">
          <LessonViewer
            lessons={groupedLessons}
            currentModuleId={selectedModuleId}
            onModuleChange={handleModuleChange}
          />
        </div>
      </div>
    </div>
  )
}

export default LessonsPage